module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loadingMeters":"Loading","volume":"Volume","weight":"Gr. Weight"},"no":{"loadingMeters":"Lastm.","volume":"Volum","weight":"Br. vekt"}}')
  delete Component.options._Ctor
}
